/**
 * Filter bei Aufzeichnungen auf Typ stellen und zur Aufzeichnungen Seite weiterleiten
 * @param typeFilter
 * @param basePath
 */
window.setTypeFilterAufzeichnungen = function (typeFilter, basePath) {
    $.ajax({
        url: basePath + 'ajax/helper/aufzeichnungen/ajax.setFilterAufzeichnungenTyp',
        type: 'post',
        data: {
            typeFilter: typeFilter,
        },
        success: function () {
            window.location.href = basePath + 'aufzeichnungen/';
        }
    });
};